import { NgModuleFactory, Type } from '@angular/core';

export const indexSectionWidgets: { path: string, loadChildren: () => Promise<NgModuleFactory<any> | Type<any>> }[] = [
  {
    path: 'index-default',
    loadChildren: () => import('../module/index-default/index-default.module').then(mod => mod.IndexDefaultModule)
  },
  {
    path: 'index-collection-01',
    loadChildren: () => import('../module/index-collection/index-collection-01/index-collection-01.module').then(mod => mod.IndexCollection01Module)
  },
  {
    path: 'index-collection-02',
    loadChildren: () => import('../module/index-collection/index-collection-02/index-collection-02.module').then(mod => mod.IndexCollection02Module)
  },
  {
    path: 'index-collection-03',
    loadChildren: () => import('../module/index-collection/index-collection-03/index-collection-03.module').then(mod => mod.IndexCollection03Module)
  },
  {
    path: 'index-search-01',
    loadChildren: () => import('../module/index-search/index-search-01/index-search-01.module').then(mod => mod.IndexSearch01Module)
  },
  {
    path: 'index-search-02',
    loadChildren: () => import('../module/index-search/index-search-02/index-search-02.module').then(mod => mod.IndexSearch02Module)
  },
  {
    path: 'index-subject-01',
    loadChildren: () => import('../module/index-subject/index-subject-01/index-subject-01.module').then(mod => mod.IndexSubject01Module)
  },
  {
    path: 'index-subject-02',
    loadChildren: () => import('../module/index-subject/index-subject-02/index-subject-02.module').then(mod => mod.IndexSubject02Module)
  },
  {
    path: 'index-subject-03',
    loadChildren: () => import('../module/index-subject/index-subject-03/index-subject-03.module').then(mod => mod.IndexSubject03Module)
  },
  {
    path: 'index-subject-04',
    loadChildren: () => import('../module/index-subject/index-subject-04/index-subject-04.module').then(mod => mod.IndexSubject04Module)
  },
  {
    path: 'index-subject-05',
    loadChildren: () => import('../module/index-subject/index-subject-05/index-subject-05.module').then(mod => mod.IndexSubject05Module)
  },
  {
    path: 'index-subject-06',
    loadChildren: () => import('../module/index-subject/index-subject-06/index-subject-06.module').then(mod => mod.IndexSubject06Module)
  },
  {
    path: 'index-subject-07',
    loadChildren: () => import('../module/index-subject/index-subject-07/index-subject-07.module').then(mod => mod.IndexSubject07Module)
  },
  {
    path: 'index-subject-08',
    loadChildren: () => import('../module/index-subject/index-subject-08/index-subject-08.module').then(mod => mod.IndexSubject08Module)
  },
  {
    path: 'index-subject-09',
    loadChildren: () => import('../module/index-subject/index-subject-09/index-subject-09.module').then(mod => mod.IndexSubject09Module)
  },
  {
    path: 'index-subject-10',
    loadChildren: () => import('../module/index-subject/index-subject-10/index-subject-10.module').then(mod => mod.IndexSubject10Module)
  },
  {
    path: 'index-quiz-01',
    loadChildren: () => import('../module/index-quiz/index-quiz-01/index-quiz-01.module').then(mod => mod.IndexQuiz01Module)
  },
  {
    path: 'index-quiz-02',
    loadChildren: () => import('../module/index-quiz/index-quiz-02/index-quiz-02.module').then(mod => mod.IndexQuiz02Module)
  },
  {
    path: 'index-article-01',
    loadChildren: () => import('../module/index-article/index-article-01/index-article-01.module').then(mod => mod.IndexArticle01Module)
  },
  {
    path: 'index-article-02',
    loadChildren: () => import('../module/index-article/index-article-02/index-article-02.module').then(mod => mod.IndexArticle02Module)
  },
  {
    path: 'index-banner-02',
    loadChildren: () => import('../module/index-banner/index-banner-02/index-banner-02.module').then(mod => mod.IndexBanner02Module)
  },
  {
    path: 'index-banner-03',
    loadChildren: () => import('../module/index-banner/index-banner-03/index-banner-03.module').then(mod => mod.IndexBanner03Module)
  },
  {
    path: 'index-banner-04',
    loadChildren: () => import('../module/index-banner/index-banner-04/index-banner-04.module').then(mod => mod.IndexBanner04Module)
  },
];

export function indexSectionArrayToObj() {
  const result = {};
  for (const w of indexSectionWidgets) {
    result[w.path] = w.loadChildren;
  }
  return result;
}
